var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-content",
    [
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c("ResearchParameters", {
            attrs: { medias: _vm.medias },
            on: { search: _vm.search }
          }),
          _vm._v(" "),
          _c("ResearchResults", { attrs: { rows: _vm.medias } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }